(function () {
    const sliderCache = new WeakMap();
    const sliderContainerSel = '.slider-container', beforeBtnClass = 'btn-slider-before', nextBtnClass = 'btn-slider-next', notFound = ' element not found';
    document.addEventListener('click', function (e) {
        const el = e.target.closest(`${sliderContainerSel} .${beforeBtnClass}, ${sliderContainerSel} .${nextBtnClass}`);
        if (!el)
            return;
        const $slider = el.closest(sliderContainerSel);
        if (!$slider)
            throw new Error("Slider" + notFound);
        sliderMove($slider, el.classList.contains(nextBtnClass));
    });
    function getSlider($slider) {
        let sliderData = sliderCache.get($slider);
        if (!sliderData) {
            const $slide = $slider.querySelector('article, .card');
            if (!$slide)
                throw new Error("Slide" + notFound);
            const $scroll = $slider.querySelector(':scope > .slider');
            if (!$scroll)
                throw new Error("Scroll" + notFound);
            const $beforeBtn = $slider.querySelector('.' + beforeBtnClass);
            if (!$beforeBtn)
                throw new Error("Before btn" + notFound);
            const $nextBtn = $slider.querySelector('.' + nextBtnClass);
            if (!$nextBtn)
                throw new Error("Next btn" + notFound);
            const gap = parseFloat(getComputedStyle($slide).getPropertyValue('--gap'));
            sliderData = {
                gap: gap * 10,
                scroll: $scroll,
                nextBtn: $nextBtn,
                beforeBtn: $beforeBtn,
                slideWidth: $slide.offsetWidth,
            };
            sliderCache.set($slider, sliderData);

            $scroll.addEventListener('scroll', debounce(onSliderScroll, {
				wait: 100,
				maxTimeout: 500,
			}));
        }
        return sliderData;
    }
    function sliderMove($slider, doNext) {
        const sliderData = getSlider($slider);
        sliderData.scroll.scrollBy({
            left: (sliderData.slideWidth + sliderData.gap) * (doNext ? 1 : -1),
            behavior: 'auto',
        });
    }
    function onSliderScroll(e) {
        if (!e.target)
            return;
        const $slider = e.target.parentElement;
        if (!$slider)
            throw new Error("Slider" + notFound);
        const sliderData = sliderCache.get($slider);
        if (!sliderData)
            throw new Error("Slider data not found"); // should not happen
        const { scroll, beforeBtn, nextBtn } = sliderData;
        beforeBtn.classList.toggle('hidden', scroll.scrollLeft === 0);
        nextBtn.classList.toggle('hidden', scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth);
    }
})();
